<template>
    <div id="konfigurator-order">
        <right-content-header></right-content-header>

        <h2>{{ 'Order' | translate }}</h2>

        <div class="form-type-select">
            <div class="select-content">
                <select class="form-select" v-model="$store.state.mazlicek.krmivo.tydny.value" @change="weekChanged">
                    <option :key="index" :value="tyden.pocetTydnu" v-for="(tyden, index) in weeks">{{ tyden.nazev }}
                    </option>
                </select>
            </div>
        </div>

        <div class="views-field views-field-field-model-cena-davky">
	    <div v-if="$store.state.mazlicek.krmivo.tydny.value !== 0" class="vaha-krmiva-celkem">
		<div class="cena-label">
            {{ 'Weight of the food' | translate }}
		</div>
		<div class="cena-value">
		    <span>{{ round(totalWeight / 100) / 10 }} kg / {{ round((totalWeight * 0.00220462262) * 10 | round) / 10 }} lb</span>
		</div>
	    </div>
	    <div v-else class="vaha-krmiva-celkem">
		<div class="cena-label">
            {{ 'Weight of the food' | translate }}
		</div>
		<div class="cena-value">
		    <span>{{ naZkouskuVaha }} g</span>
		</div>
	    </div>
            <div class="cena-davky" v-if="showTotalPrice">
                <div class="cena-label">
                    {{ 'Price / day' | translate }}
                </div>
                <div v-show="!priceIsBeingCalculated" class="cena-value">
                    <span>€{{ (pricePerDay + '').replace('.', ',') }}</span>
                </div>
                <div v-show="priceIsBeingCalculated" class="cena-value"><span>{{ 'recalculating' | translate }}</span></div>
            </div>
            <div class="cena-complete">
		<div class="cena-label">
            {{ 'Total price' | translate }}
		</div>
                <div v-show="!priceIsBeingCalculated" class="cena-value"><span>€{{ totalPrice }}</span></div>
                <div v-show="priceIsBeingCalculated" class="cena-value"><span>{{ 'recalculating' | translate }}</span></div>
            </div>
        </div>

        <!--<div class="form-type-checkboxes">-->
        <!--<div class="form-type-checkbox">-->
        <!--<input id="extra-baleni-checkbox" type="checkbox" v-model="$store.state.mazlicek.krmivo.extraZabalit"/>-->
        <!--<label for="extra-baleni-checkbox">Extra balení</label>-->
        <!--</div>-->
        <!--</div>-->
        <div v-if="additional_info_order" class="objednavka-btn-text">
          <span v-html="additional_info_order.content" > </span>
        </div>
        <div class="objednavka-btn">
            <button class="button" @click="objednatKrmivo">{{ 'Order Haffit' | translate }}</button>
        </div>
    </div>
</template>

<script>
    import {apiDrupal, apiSilex} from '@/api'
    import RightContentHeader from './RightContentHeader'
    import filters from '../filters'

    export default {
      components: {
        'right-content-header': RightContentHeader
      },

      data: function () {
        return {
          tydny: [],
          mazlicek: this.$store.state.mazlicek,
          loading: this.$store.state.loading,
          naZkouskuCena: 100,
          naZkouskuVaha: 100,
          additional_info_order: null,
          priceIsBeingCalculated: false
        }
      },
      computed: {
        showTotalPrice: function () {
            return this.mazlicek.krmivo.feedData && this.mazlicek.krmivo.feedData.feedRatio.showTotalPrice
        },
        imageSrc: function () {
          return 'https://dummyimage.com/200x200/000/fff&amp;text=ico'
        },
        pricePerDay () {
          if (this.$store.state.mazlicek.krmivo.tydny.value === 0) { return this.naZkouskuCena }

          // const weekCoeficient = Number(this.$store.state.mazlicek.krmivo.tydny.data.koeficient)
          // const pricePerDay = Number(this.$store.state.mazlicek.krmivo.cena.den) * Number(weekCoeficient)

          const pricePerDay = Number(this.$store.state.mazlicek.krmivo.cena.den)

          return Math.round(Number(pricePerDay) * 100) / 100
        },
        totalPrice () {
          if (this.$store.state.mazlicek.krmivo.tydny.value == 0) { return this.naZkouskuCena }

          const weeks = Number(this.mazlicek.krmivo.tydny.data.pocetTydnu)

          return Math.round(this.pricePerDay * 7 * weeks)
        },
        totalWeight () {
          if(this.mazlicek.krmivo.feedData)
            return this.mazlicek.krmivo.feedData.feedRatio.totalWeightFeedRatio
        },
        weightFeedRatio () {
          if(this.mazlicek.krmivo.feedData)
            return this.mazlicek.krmivo.feedData.feedRatio.weightFeedRatio
        },
        weeks () {
          if (this.mazlicek.jeStene) {
            return this.tydny.filter(item => item.pocetTydnu <= 4)
          } else {
            return this.tydny
          }
        }
      },
      methods: {
        weekChanged () {
          const pocetT = this.$store.state.mazlicek.krmivo.tydny.value
          this.$store.state.mazlicek.krmivo.tydny.data = this.tydny.find(item => item.pocetTydnu == pocetT)
          this.priceIsBeingCalculated = true
          this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
            this.mazlicek.krmivo.feedData = response.data.data.product.feedData
            this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
            this.$store.commit('setMazlicek', this.mazlicek)
            this.priceIsBeingCalculated = false
          })
        },
        objednatKrmivo: function () {
          this.$store.commit('setLoading', true)
          sessionStorage.pet_nid = this.mazlicek.nid
          sessionStorage.feed_nid = this.mazlicek.krmivo.nid
          const trackingInfo = {
              value: this.totalPrice,
              items: [{
                  id: this.mazlicek.krmivo.nid,
                  google_business_vertical: 'retail'
              }]
          }

          this.$gtag.query('event','add_to_cart', trackingInfo)

            let mazlicek = {}
            mazlicek.nid = this.$store.state.mazlicek.nid

            mazlicek.krmivo = {}
            mazlicek.krmivo.nid = this.$store.state.mazlicek.krmivo.nid
            mazlicek.krmivo.pocetTydnu = this.$store.state.mazlicek.krmivo.tydny.data.pocetTydnu
            mazlicek.krmivo.koeficient = this.$store.state.mazlicek.krmivo.tydny.data.koeficient

            apiDrupal.post('/set-order', {
                mazlicek: mazlicek
              })
                .then(response => {
                    // sessionStorage.konfigurator = {};
                    window.location.href = '/kosik'
                })
                .catch(function (error) {
                  console.error(error)
                })
        },
        afterMounted: function () {
          let url = '/objednavka/tydny'
          if (this.mazlicek.jeStene) { url += '?puppy=true' }
          apiSilex.get(url).then((response) => {
            this.tydny = response.data.filter(item => item.pocetTydnu > 1)

            this.weekChanged()
          })

          apiSilex.get('/additional_info/2').then(response => {
            this.additional_info_order = response.data
          }).catch(error => console.error(error))
        },
        round (value) {
          value = Number(value)
          return Math.round(value)
        },
      },
      mounted: function () {
        // eslint-disable-next-line eqeqeq
        if (this.mazlicek.krmivo.nid != 0) {
          this.afterMounted()
        }
      },
      watch: {
        'mazlicek.krmivo.tydny.value': {
          deep: true,
          handler: function (val) {
            this.weekChanged()
          }

        },
        'mazlicek.productLoaded': {
          deep: true,
          handler: function (val) {
            if (val.value) { this.afterMounted() }
          }
        },
        'mazlicek.petLoaded': {
          deep: true,
          handler: function (val) {
//                    if (val.value)
                    // this.mountinMethod()
          }
        }
//            'mazlicek.krmivo.cena': {
//                deep: true,
//                handler: function (val) {
//                    console.log('asdasdasd');
//                    this.weekChanged()
//                }
//            }
      }
    }
</script>



// WEBPACK FOOTER //
// Order.vue?48cc46da